import React, { useState } from "react";
import menuQR from "../../assets/QRPageHero.webp";
import SubTopHeader2 from "../../menus/SubTopHeader2";

const FORM_ENDPOINT = "https://formspree.io/f/your-id-here"; // ← update
const WHATSAPP_PHONE = "254700000000"; // ← update (no +)

export default function RestaurantDigitalServicesPage() {
    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState(null);

    // Add a tiny shadow to the nav on scroll (subtle polish)
    // useEffect(() => {
    //     const onScroll = () => {
    //         const nav = document.querySelector(".nav");
    //         if (!nav) return;
    //         if (window.scrollY > 8) nav.classList.add("scrolled");
    //         else nav.classList.remove("scrolled");
    //     };
    //     onScroll();
    //     window.addEventListener("scroll", onScroll, { passive: true });
    //     return () => window.removeEventListener("scroll", onScroll);
    // }, []);

    async function handleSubmit(e) {
        e.preventDefault();
        const form = e.target;
        const data = new FormData(form);

        setSending(true);
        setStatus(null);

        try {
            const res = await fetch(FORM_ENDPOINT, { method: "POST", body: data });
            if (res.ok) {
                setStatus({ type: "ok", message: "Message sent! We’ll reply soon." });
                form.reset();
            } else {
                setStatus({ type: "err", message: "Something went wrong. Try WhatsApp." });
            }
        } catch (err) {
            setStatus({ type: "err", message: "Network error. Try WhatsApp." });
        } finally {
            setSending(false);
        }
    }

    const whatsappUrl = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(
        "Hi! I'd like info about your restaurant digital services."
    )}`;

    return (
        <div className="page">
            <SubTopHeader2 />

            {/* ✅ HERO */}
            <section className="hero">
                <div className="hero-bg" />
                <div className="container hero-grid">
                    <div>
                        <h1>
                            Digital Menus & Full-Stack Marketing
                            <span className="h1-accent"> for Restaurants</span>
                        </h1>
                        <p className="muted lead">
                            QR menu access, conversion-focused websites, crisp poster designs, mouth-watering photography,
                            and social media that actually brings customers in.
                        </p>

                        <div className="row gap hero-actions">
                            <a href="#contact" className="btn primary">Get Started</a>
                            <a href="#services" className="btn ghost">Explore Services</a>
                        </div>

                        <div className="trustbar">
                            <span>2-week website delivery</span>
                            <span>24h response time</span>
                            <span>100+ menus delivered</span>
                        </div>
                    </div>

                    <div className="hero-img-wrap">
                        <figure className="hero-img" aria-label="Tabletop restaurant menu with QR code">
                            <picture>
                                {/* smaller screens first */}
                                <source
                                    media="(max-width: 640px)"
                                    srcSet={menuQR}
                                />
                                <img
                                    src={menuQR}
                                    alt="Printed restaurant menu on a wooden table with a QR code for scanning"
                                    loading="eager"
                                    decoding="async"
                                />
                            </picture>

                            {/* subtle QR accent */}
                            <figcaption className="hero-badge">
                                <span className="tiny muted">Scan Menu</span>
                                <span className="qr-dot" aria-hidden="true"></span>
                            </figcaption>
                        </figure>
                    </div>
                </div>
            </section>

            {/* ✅ SERVICES */}
            <section className="section">
                <div className="container">
                    <h2>Services</h2>
                    <p className="muted max">
                        Everything your restaurant needs to look modern, trustworthy, and conversion-ready.
                    </p>

                    <div className="grid cards">
                        <div className="card">
                            <h3>Digital Menu (QR Code)</h3>
                            <p className="muted small">Fast, mobile-friendly menus with no printing hassle.</p>
                        </div>
                        <div className="card">
                            <h3>Website Development</h3>
                            <p className="muted small">Speedy, SEO-ready sites designed to book tables and calls.</p>
                        </div>
                        <div className="card">
                            <h3>Digital Poster Designs</h3>
                            <p className="muted small">Promo visuals for screens, WhatsApp, or print.</p>
                        </div>
                        <div className="card">
                            <h3>Food Photography</h3>
                            <p className="muted small">Clean, appetizing shots that make people hungry.</p>
                        </div>
                        <div className="card">
                            <h3>Social Media Management</h3>
                            <p className="muted small">Content, schedules, and ads — done for you.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ✅ PRICING */}
            <section className="section">
                <div className="container">
                    <h2>Pricing</h2>
                    <p className="muted max">Start small or get a full digital transformation.</p>

                    <div className="grid pricing">
                        <div className="price">
                            <h3>Starter</h3>
                            <p className="price-num">KES 2,000 *</p>
                            <ul>
                                <li>QR Menu Setup</li>
                                {/* <li>1-Page Website</li>
                                <li>3 Promo Posters</li> */}
                            </ul>
                            <a href="#contact" className="btn block">Choose Starter</a>
                            <p className="note">
                                * This is a monthly subscription service.
                            </p>
                        </div>

                        <div className="price popular" aria-label="Most popular">
                            <div className="badge">Most Popular</div>
                            <h3>Pro</h3>
                            <p className="price-num">KES 20,000 *</p>
                            <ul>
                                <li>QR Menu System</li>
                                <li>Website Development</li>
                            </ul>
                            <a href="#contact" className="btn primary block">Choose Pro</a>
                            <p className="note">
                                * This includes a 2,000 qr System subscription amount. The rest is a one off charge.
                            </p>
                        </div>

                        <div className="price">
                            <h3>Growth</h3>
                            <p className="price-num">KES 55,000 *</p>
                            <ul>
                                <li>QR Menu System</li>
                                <li>Website Development</li>
                                <li>Instagram + Facebook Management</li>
                                <li>3 Promo Posters</li>
                            </ul>
                            <a href="#contact" className="btn block">Choose Growth</a>
                            <p className="note">
                                * This includes a 2,000 qr System subscription amount. The rest is a one off charge.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ✅ CONTACT */}
            <section className="section contact-section">
                <div className="container contact-grid">
                    <aside className="contact-aside">
                        <h2>Let’s cook up something great</h2>
                        <p className="muted">Tell us what you need and we’ll prepare a plan for you.</p>
                        <ul className="bullets">
                            <li>No long forms — quick reply</li>
                            <li>We can meet on WhatsApp</li>
                            <li>Portfolio available on request</li>
                        </ul>
                    </aside>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        {/* Formspree niceties */}
                        <input type="hidden" name="_subject" value="New Restaurant Inquiry" />
                        <input type="text" name="_gotcha" className="honeypot" tabIndex="-1" autoComplete="off" />

                        <div className="two">
                            <div className="field">
                                <label htmlFor="restaurant">Restaurant Name</label>
                                <input id="restaurantName" name="restaurant" type="text" autoComplete="organization" />
                            </div>
                            <div className="field">
                                <label htmlFor="name">Your Name</label>
                                <input id="name" name="name" type="text" required autoComplete="name" />
                            </div>
                        </div>

                        <div className="two">
                            <div className="field">
                                <label htmlFor="email">Email</label>
                                <input id="email" name="email" type="email" required autoComplete="email" />
                            </div>
                            <div className="field">
                                <label htmlFor="phone">Phone</label>
                                <input id="phone" name="phone" type="tel" placeholder="+254 7xx xxx xxx" />
                            </div>
                        </div>

                        <div className="field">
                            <label>Services Needed</label>
                            <div className="pills" role="group" aria-label="Services needed">
                                {["QR Menu", "Website", "Poster Designs", "Food Photography", "Social Media"].map((opt) => (
                                    <label key={opt} className="pill">
                                        {/* name as array for Formspree grouping */}
                                        <input type="checkbox" name="services[]" value={opt} />
                                        {opt}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor="message">Message</label>
                            <textarea id="message" name="message" rows="5" required placeholder="Tell us a bit about your restaurant and goals…" />
                        </div>

                        <div className="row gap wrap">
                            <button type="submit" className="btn primary" disabled={sending}>
                                {sending ? "Sending…" : "Send Message"}
                            </button>

                            <a href={whatsappUrl} className="btn whats" target="_blank" rel="noreferrer">
                                Chat on WhatsApp
                            </a>

                            {status && <span className={`status-msg ${status.type}`}>{status.message}</span>}
                        </div>
                    </form>
                </div>
            </section>

            {/* ✅ Floating WhatsApp Button */}
            <a href={whatsappUrl} className="fab-whatsapp" target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp">
                WhatsApp
            </a>

            <footer className="footer">
                <div className="container footer-row">
                    <span className="muted tiny">© {new Date().getFullYear()} Bites & Bytes</span>
                    <a className="tiny" href="#home">Back to top ↑</a>
                </div>
            </footer>
        </div>
    );
}
